import {useEffect, useReducer, useRef, useState } from "react";
import "./index.css";
import FileUploader from "../FileUploader";
import TableGrid from "../TableGrid/tableGrid";
import papa from "papaparse";
import { GetAllSalesPersons, uploadCsv } from "../../Services/Dashboard/tableGridService";
import Modal from "react-modal";
import { RotatingLines } from "react-loader-spinner";
import basestyle from "../../Pages/Base.module.css";
import { useNavigate } from "react-router-dom";
import { setRefValues } from "../../Services/Dashboard/salesPersonGridService";
import { useRefTypes, useVerticals } from "../../hooks/useVerticals";
import Button from "../Button";
import SearchWithControls from "../SearchWithControls";
import { CUSTOMER_SEARCH_REDUCER } from "../../Utils/customer-search-reducer";
import AddUserIcon from "../../Assests/Icons/AddUserIcon";
import { CustomerSearchActionTypes } from "../../Utils/constants";
import BulkUploadErrorModal from "../BulkUploadErrorModal";
import Loader from "../Loader";


const SalesPersonGrid = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [rowData, setRowData] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [showRefModal, setShowRefModal] = useState(false);
  const { data: verticals, isLoading: verticalsLoading, fetchVerticals } = useVerticals();
  const [refTypes, fetchRefTypes] = useRefTypes(verticals);
  const [salesPersonSearchState, salesPersoSearchDispach] = useReducer(
    CUSTOMER_SEARCH_REDUCER,
    { searchValue: "", searchByValue: "userId", status: null }
  );
  const [data, setData] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const offset = 200;
  const [isPrevious, setIsPrevious] = useState(false);
  const [isNext, setIsNext] = useState(false);
  const [isLoadingSalesPerson, setIsLoadingSalesPerson] = useState(false);


  const onSelectVertical = (e) => {
    fetchRefTypes(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const refValue = formData.get("refValue");
    const refType = formData.get("refType");
    const vertical = formData.get("pcmId");
    const data = {
      input: {
        request: [
          {
            refType: refType,
            refValue: refValue,
            pcmId: vertical,
          },
        ],
      },
    };
    setRefValues(data).then((res) => {
      if (res.status === 200) {
        setShowRefModal(false);
        fetchRefTypes();
        alert("Ref Value Added Successfully");
      } else {
        alert(res.errorMessage);
      }
      // window.location.reload();
    });
  };

  const navigate = useNavigate();
  const addAnother = () => {
    navigate("/dashboard/add-another-user");
  };

  const customStyles = {
    overlay: {
      zIndex: 15,
      background: "rgba(0, 0, 0, 0.7)",
    },
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      padding: "0px",
      width: "430px",
      height: "400px",
    },
  };

  const closeModal = () => {
    setShowModal(false);
    setRowData({});
  };
  const handleFile = (file) => {
    if (!file) {
      return;
    }
    papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        const filteredData = results?.data?.filter(
          (item) => item.UserId !== ""
        );

        const getPositionCodeDetails = (data) => {
          const filteredDataLength = Object.keys(data).length;
          const resultArray = [];
          for (let i = 1; i <= filteredDataLength; i++) {
            const refKey = data[`RefKey${i}`];
            const refValue = data[`RefValue${i}`];
            if (refKey && refValue) {
              resultArray.push({
                refType: refKey,
                refValue: refValue,
              });
            }
          }
          return resultArray;
        };

        const data = filteredData?.map((item, index) => ({
          userId: item.UserId,
          providerId: "Ninjacart",
          __uploadNumber: index++,
          positionCodeAdditionalDetails: getPositionCodeDetails(item),
        }));
        setIsLoading(true);
        setShowModal(true);
        uploadCsv({
          dataMap: {
            salesPersons: data,
          },
          workflowName: "BulkUploadAdminToolWorkflow",
        })
          .then((res) => {
            const { data } = res?.response?.data || {};
            const { successRows, failedRows } = data || {};
            setRowData({ successRows, failedRows });
            if (successRows?.length) {
              setData([]);
              pageNumber > 0 ? setPageNumber(0) : fetchAllUsers();
            }
            setIsLoading(false);
          })
          .catch((error) => {
            setIsLoading(false);
            return error;
          });
      },
    });
  };

  const fetchAllUsers = () => {
    setIsNext(false);
    setIsPrevious(false);
    setIsLoadingSalesPerson(true);
    const searchParams = {};
    const paramValue = !!salesPersonSearchState.searchValue
      ? [salesPersonSearchState.searchValue]
      : undefined;
    if (salesPersonSearchState.searchByValue === 'userId') {
      searchParams.userId = paramValue;
    } else if (salesPersonSearchState.searchByValue === 'employeeId'){
      searchParams.employeeId = paramValue;
    }
    else {
      searchParams.phoneNumber = paramValue;
    }
    GetAllSalesPersons({
      input: {
        limit: 200,
        offset: offset * pageNumber,
        ...searchParams
      },
    })
      .then((res) => {
          setIsLoadingSalesPerson(false);
          setData(res?.data?.data || []);
          const isEnableNext = res?.data?.data?.length === offset;
          setIsNext(isEnableNext);
          setIsPrevious(pageNumber > 0);
      })
      .catch((err) => {
        setIsLoadingSalesPerson(false);
        console.log("err", err);
      });
  };


  const fetchAllUsersRef = useRef(fetchAllUsers);
  fetchAllUsersRef.current = fetchAllUsers;

  useEffect(() => {
    fetchAllUsersRef.current();
  }, [pageNumber]);

  useEffect(() => {
    if (
      salesPersonSearchState.status === CustomerSearchActionTypes.SEARCH ||
      salesPersonSearchState.status === CustomerSearchActionTypes.RESET
    ) {
      fetchAllUsersRef.current();
    }
  }, [salesPersonSearchState.status]);

  const onSearchInputChange = (event) => {
    salesPersoSearchDispach({
      type: CustomerSearchActionTypes.SET_SEARCH_VALUE,
      payload: {
        searchValue: event?.target?.value?.toString()?.trim(),
        status: CustomerSearchActionTypes.VALUE_UPDATE,
      },
    });
  }
  const onSearchByChange = (event) => {
    salesPersoSearchDispach({
      type: CustomerSearchActionTypes.SET_SEARCH_BY_VALUE,
      payload: {
        searchByValue: event?.target?.value?.toString()?.trim(),
        status: CustomerSearchActionTypes.VALUE_UPDATE,
      },
    });
  }
  const onSearchCustomers = () => {
    if (salesPersonSearchState.status !== CustomerSearchActionTypes.SEARCH) {
      setData([]);
      setPageNumber(0);
      salesPersoSearchDispach({
        type: CustomerSearchActionTypes.SET_STATUS,
        payload: {status: CustomerSearchActionTypes.SEARCH},
      });
     }
  }
  const onClearSearch = () => {
    if (salesPersonSearchState.status !== CustomerSearchActionTypes.RESET) {
      setData([]);
      setPageNumber(0);
      salesPersoSearchDispach({type: CustomerSearchActionTypes.RESET});
    }
  }

  const onAddRefValue = () => {
    setShowRefModal(true);
    fetchVerticals();
  }

  return (
    <>
      <Modal isOpen={showRefModal} style={customStyles}>
        <button
          className="dashboard-upload-modal-close-btn"
          onClick={() => setShowRefModal(false)}
        >
          X
        </button>
        <form method="post" onSubmit={handleSubmit}>
          <div className="dashboard-upload-ref-container">
            {isLoading && (
              <>
                <div className="dashboard-upload-modal-text">
                  <h2>CSV File Is Being Uploaded...Please Wait.</h2>
                </div>
                <RotatingLines
                  strokeColor="grey"
                  strokeWidth="5"
                  animationDuration="1"
                  width="80"
                  visible={true}
                />
              </>
            )}
            <div className="dashboard-upload-ref-title">Add Ref Value</div>

            <div className="dashboard-ref-input row">
              <p className="dashboard-ref-input-label">Select Vertical</p>
              <select
                className="form-control"
                name="pcmId"
                required
                onChange={(e) => onSelectVertical(e)}
              >
                {!verticalsLoading &&
                  verticals?.length !== 0 &&
                  verticals?.map((item) => (
                    <option value={item.id} key={item.id}>
                      {item?.refValue}
                    </option>
                  ))}
              </select>
            </div>
            <div className="dashboard-ref-input row">
              <p className="dashboard-ref-input-label">Select Ref Key</p>
              <select required className="form-control" name="refType">
                {refTypes?.length !== 0 &&
                  refTypes?.map((item) => (
                    <option value={item} key={item}>
                      {item}
                    </option>
                  ))}
              </select>
            </div>
            <div className="dashboard-ref-input row">
              <p className="dashboard-ref-input-label">Enter Ref Value</p>
              <input required className="form-control" name="refValue" />
            </div>
            <div className="dashboard-ref-submit row">
              <button
                name="submit-btn"
                className={basestyle.button_modal}
                type="submit"
              >
                Submit
              </button>
            </div>
          </div>
        </form>
      </Modal>
      {showModal && (
        <BulkUploadErrorModal
          isLoading={isLoading}
          successRows={rowData.successRows}
          failedRows={rowData.failedRows}
          closeModal={closeModal}
        />
      )}
      <div className="dashboard-inner-container">
      {(isLoading || isLoadingSalesPerson) && <Loader/>}
        <p className="flex items-center justify-center mt-16 text-lg text-[#0e76a8]"><b>Sales Persons</b></p>
        <div className="flex justify-between items-center flex-wrap">
          <SearchWithControls
            className="py-3 px-2"
            customerSearchState={salesPersonSearchState}
            onSearchInputChange={onSearchInputChange}
            onSearchByChange={onSearchByChange}
            onSearchCustomers={onSearchCustomers}
            onClearSearch={onClearSearch}
            dropdownData={[
              { value: "userId", label: "User ID" },
              { value: "empPhoneNumber", label: "Phone Number" },
              { value: "employeeId", label: "Employee ID" },
            ]}
          />
          <div className="flex justify-center flex-wrap py-3 px-2">
            <Button
              className="mr-2 flex items-center"
              onClick={onAddRefValue}
            >
              <AddUserIcon />
              <span className="ml-1">Add Ref Value</span>
            </Button>
            <FileUploader
              className="mr-2"
              handleFile={handleFile}
            />
            <Button className="flex items-center" onClick={() => addAnother()}>
              <AddUserIcon />
              <span className="ml-1"> Add Another User</span>
            </Button>
          </div>
        </div>
        <TableGrid
          salesPersonsData={data}
          setSalesPersonsData={setData}
          setPageNumber={setPageNumber}
          pageNumber={pageNumber}
          isPrevious={isPrevious}
          isNext={isNext}
          isLoading={isLoadingSalesPerson}
          onFetchData={fetchAllUsers}
        />
      </div>
    </>
  );
  
};

export default SalesPersonGrid;
